import { PipeTransform } from '@angular/core';
import { CurrencyPipe } from './currency.pipe';
var CurrencyWithDecimalsPipe = /** @class */ (function () {
    function CurrencyWithDecimalsPipe(currencyPipe) {
        this.currencyPipe = currencyPipe;
    }
    CurrencyWithDecimalsPipe.prototype.transform = function (val) {
        var decimals = val.toString().split('.').length >= 2 ? val.toString().split('.')[1].slice(0, 2) : '00';
        return (val.toString().includes('-') ? '-' : '') + "$ " + this.currencyPipe.addThousandsSeparator(val.toString().replace('-', '').split('.')[0], '.') + "," + decimals.padEnd(2, '0');
    };
    return CurrencyWithDecimalsPipe;
}());
export { CurrencyWithDecimalsPipe };
